
/**
 * @param email string with the email address to check
 * @returns true if the email has a valid format, false if not
 */
export const validateEmail = (_email) => {
  const checker = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

  if (!_email) return false;

  let emailChecker = _email.split("@");
  if (emailChecker.length !== 2) return false;

  let left = emailChecker[0];
  let domain = emailChecker[1];
  if (left.length > 64) return false;
  else if (domain.length > 255) return false;

  let mainTaster = domain.split(".");
  if (
    mainTaster.some(function (part) {
      return part.length > 63;
    })
  )
    return false;

  return checker.test(_email);
};
